document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.donation-amount');
  const payBtn = document.querySelector('.donation-card__pay');

  if (!buttons.length || !payBtn) return;

  let selectedVariant = null;

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      buttons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      selectedVariant = btn.dataset.variantId;
      payBtn.disabled = false;
    });
  });

  payBtn.addEventListener('click', async () => {
    if (!selectedVariant) return;

    await fetch('/cart/clear.js', { method: 'POST' });

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: selectedVariant,
        quantity: 1
      })
    });

    window.location.href = '/checkout';
  });
});
